import { Utils, StringUtils } from "neo-common";
import { GameEngine, ClientHost } from "neo-games";
import { GameConfiguration } from "./GameConfiguration";
import { GameDefinition } from "./GameDefinition";
import { GameApp } from "../Game/GameApp";

export class AppContext extends GameEngine.AppContextBase<GameConfiguration, GameDefinition> {
    private static _current: AppContext = null;

    constructor(gameConfiguration: GameConfiguration, gameDefinition: GameDefinition) {
        super(gameConfiguration, gameDefinition, GameApp.key);

        AppContext._current = this;
    }

    public static get current(): AppContext {
        return AppContext._current;
    }

    public static get gameConfiguration(): GameConfiguration {
        return AppContext._current == null ? null : AppContext._current.gameConfiguration;
    }

    public static get gameDefinition(): GameDefinition {
        return AppContext._current.gameDefinition;
    }

    public static get clientHost(): ClientHost.IClientHost {
        return AppContext._current.clientHost;
    }

    public setHideAmounts(hideAmounts: boolean): void {
        if (AppContext.clientHost != null) {
            AppContext.clientHost.updateSharedSetting("HideAmounts", hideAmounts.toString());
        }
    }

    public getHideAmounts(): boolean {
        if (AppContext.clientHost != null) {
            if (AppContext.gameConfiguration.HideAmountsEnabled) {
                const hideAmounts = AppContext.clientHost.getSharedSetting("HideAmounts");

                if (!Utils.isNullOrUndefined(hideAmounts)) {
                    return StringUtils.parseBoolean(hideAmounts);
                }
            }
        }

        return false;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Common/AppContext.ts
 **/